import api from './api';

const sanitizeUser = (u) => {
  if (!u) return u;
  const { password, remember_token, ...rest } = u;
  return rest;
};

export const userManagementApi = {
  async list(params = {}) {
    const query = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v !== undefined && v !== null && v !== '') {
        query.append(k, String(v));
      }
    }
    const qs = query.toString();
    const { data } = await api.get(`/users${qs ? `?${qs}` : ''}`);
    const users = (data?.data || []).map(sanitizeUser);
    const pagination = {
      current_page: data?.current_page ?? 1,
      last_page: data?.last_page ?? 1,
      per_page: data?.per_page ?? 15,
      total: data?.total ?? users.length,
      from: data?.from ?? null,
      to: data?.to ?? null,
    };
    return { users, pagination };
  },

  async create(payload) {
    const { data } = await api.post('/users', payload);
    return { user: sanitizeUser(data?.user), message: data?.message };
  },

  async get(id) {
    const { data } = await api.get(`/users/${id}`);
    return sanitizeUser(data?.user);
  },

  async update(id, payload) {
    const { data } = await api.put(`/users/${id}`, payload);
    return { user: sanitizeUser(data?.user), message: data?.message };
  },

  async remove(id) {
    const { data } = await api.delete(`/users/${id}`);
    return { message: data?.message };
  },
};

export default userManagementApi;
